import { useEffect } from 'react';

import { HubConnectionState } from '@microsoft/signalr';
import { BridgeEventMethod, FullMessage, SimpleMessage } from '@scaleaq/sitecontrol-lib';

import { useCurrentSiteConnection } from '../connection';

type MessageType = FullMessage | SimpleMessage;
type UseBridgeEventProps<T extends MessageType | unknown[]> = {
  bridgeEventMethod: BridgeEventMethod;
  eventCallback: (rgs: T) => void;
};

export const subscribedToEvent: { [key: string]: boolean } = {};

export const updateSubscribedToEvent = ({
  eventNamesOrIds,
  eventNameForIds,
  currentSiteId,
}: {
  eventNamesOrIds: string[];
  eventNameForIds?: string;
  currentSiteId: string;
}) => {
  eventNamesOrIds.forEach(id => {
    const subscribedToEventKey = `${currentSiteId}-${eventNameForIds}-${id}`;
    if (!subscribedToEvent[subscribedToEventKey]) {
      subscribedToEvent[subscribedToEventKey] = true;
    }
  });
};
export const useBridgeRegistration = <T extends MessageType>({
  bridgeEventMethod,
  eventCallback,
}: UseBridgeEventProps<T>) => {
  const methodName = bridgeEventMethod.toString();

  const { connection, isLoading } = useCurrentSiteConnection();

  useEffect(() => {
    if (isLoading || connection?.state !== HubConnectionState.Connected) {
      return;
    }
    connection?.on(methodName, eventCallback);

    return () => {
      connection?.off(methodName, eventCallback); // Cleanup
    };
  }, [eventCallback, isLoading, methodName, connection]);
};
